export enum ActivityType {
    campaign = "campaign",
    subject = "subject"
}